<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Student Scholarship</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Student Scholarship</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="student-scholarship ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table width="100%" class="table table-bordered table--3">
            <thead>
              <tr>
                <th>Type</th>
                <th>Agency / Authority </th>
                <th>Beneficiary</th>
              </tr>
            </thead>
            <tbody>
              <tr height="30">
                <td style="text-align: center;">e-scholarship for Reserve Category - SC, SBC,OBC,&amp; VJNT Candidates
                </td>
                <td style="text-align: center;">Govt. of Maharashtra State./ Govt. of India</td>
                <td>a) <b>For Freeship</b>
                  SC- 100 % Tuition , Development &amp; Exam fees without income limit
                  SBC/VJNT 100 % Tuition &amp; Exam fees with income limit up to Rupees Six Lacs.
                  OBC – 50 % Tuition &amp; Exam fees with income limit up to Rupees Six Lacs.
                  <br><br>b) <b>For e- Scholarship</b>
                  SC- 100 % Tuition, Development &amp; Exam with income limit up to Rupees One Lacs.
                  SBC/VJNT 100 % Tuition fees with income limit up to Rupees One Lac.
                  OBC – 50 % Tuition fees with income limit up to Rupees One Lac.
                  www.mahadbtmahait.gov.in
                  (As Per SPPU Fee Structure )
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p><strong>BBA, BCA, BSc. (Computer Science) – Only SC Category Scholarship</strong></p>
        <p><strong>B. Com. – All Category Scholarship</strong></p>
        <h4 class="yellow-color mt-3 fw-bold">Document required for Scholarship</h4>
        <p>Photostat Copy of:-</p>
        <ul class="list-before">
          <li> Passport size photograph with signatures of the student</li>
          <li> Father Income certificate </li>
          <li> Ration Card</li>
          <li> Domicile &amp; Nationality Certificate</li>
          <li> All Mark sheets from SSC onward</li>
          <li> Leaving Certificate</li>
          <li> Migration Certificate</li>
          <li> AADHAR Card – Student, Father, Mother </li>
          <li>Nationalized Bank Passbook</li>
          <li>Cancelled bank cheque leaf</li>
          <li>Aadhar card link form with Bank Account</li>
          <li>Gap Certificate (If Applicable)</li>
          <li>Death Certificate of Father (If Applicable)</li>
          <li> Cast Certificate (For Reserve Category Students only)</li>
          <li> Cast Validity Certificate (For Reserve Category Students only)</li>
          <li>Death Certificate of Father (If Applicable)</li>
        </ul>
      </div>
    </div>
  </div>
</section>
